import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Home_h5 from '@/views/home-h5'
import JXHH from '@/views/JXHH'
import Promotion from '@/views/promotion'
import Promotion_document from '@/views/promotion-document'
import Promotion_business from '@/views/promotion-business'
import Promotion_h5 from '@/views/promotion-h5'
import Amuletj from '@/views/amuletj'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Promotion
    },
    {
      path: '/m',
      name: 'home-h5',
      component: Promotion_h5
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: Promotion
    },
    {
      path: '/promotion/m',
      name: 'promotion-h5',
      component: Promotion_h5
    },
    {
      path: '/promotion/document',
      name: 'promotion-document',
      component: Promotion_document
    },
    {
      path: '/promotion/business',
      name: 'promotion-business',
      component: Promotion_business
    },
    {
      path: '/wholesale',
      name: 'wholesale',
      component: Home
    },
    {
      path: '/wholesale/m',
      name: 'wholesale-h5',
      component: Home_h5
    },
    {
      path: '/jxhh',
      name: 'jxhh',
      component: JXHH
    },
    {
      path: '/amuletj',
      name: 'amuletj',
      component: Amuletj
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js